import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "visibility", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: this.previewUrl,
    target: "_blank",
    class: "btn btn-icon btn-secondary"
  }, _hoisted_3, 8, _hoisted_1))
}